import * as chevrotain from 'chevrotain';
import _ from 'lodash';

class CodeManager {

    constructor() {
        this.codeDB = [];
        this.codeDB.push("R0 <- MEM[R1 + 8]\n"
                        +"R2 <- R0 * 3\n"
                        +"R3 <- MEM[R1 + 12]\n"
                        +"R4 <- R3 * 5\n"
                        +"R0 <- R2 + R4");

        this.codeDB.push("R5 <- MEM [R3+24]\n"
                        +"R6 <- MEM [R4+16]\n"
                        +"R7 <- R6 + R5\n"
                        +"R1 <- R6 - R5\n"
                        +"R5 <- R7 * R1\n"
                        +"R4 <- R4 + 4");

        this.codeDB.push("R2 <- R0 * R1\n"
                        +"R3 <- MEM[R2 + 4]\n"
                        +"R7 <- MEM[R2 + 8]\n"
                        +"R5 <- R3 + R7\n"
                        +"R6 <- R0 + 12\n"
                        +"R4 <- R3 * R6\n"
                        +"R4 <- R4 - R5");

        this.codeDB.push("D1 <- MEM [R0+0]\n"
                        +"D1 <- D0 * D1\n"
                        +"D3 <- D2 / D1\n"
                        +"D2 <- MEM [R1+0]\n"
                        +"D2 <- D0 + D2\n"
                        +"D3 <- D3 - D2\n"
                        +"MEM [R1+16] <- D3");

        this.codeDB.push("D1 <- D2 - D1\n"
                        +"D3 <- D1 + D2\n"
                        +"D0 <- D3 + D1\n"
                        +"D0 <- D2 / D0\n"
                        +"D1 <- MEM [R0+0]\n"
                        +"D2 <- D1 + D2\n"
                        +"D0 <- D0 + D2");

        this.codeDB.push("R2 <- MEM [R0+0]\n"
                        +"R3 <- R0 * R2\n"
                        +"R7 <- R4 / R3\n"
                        +"R5 <- MEM [R1+8]\n"
                        +"R6 <- R2 + R5\n"
                        +"R5 <- R5 / R6\n"
                        +"R7 <- R6 * R5");

        this.codeDB.push("R1 <- R2 - R3\n"
                        +"R4 <- MEM [R1]\n"
                        +"R6 <- R4 + R1\n"
                        +"R0 <- R2 / R6\n"
                        +"R7 <- MEM [R5]\n"
                        +"R3 <- R7 + R2\n"
                        +"R7 <- R7 + R6");

        this.codeDB.push("D0 <- D1 * D2\n"
                        +"D3 <- D0 + D3\n"
                        +"MEM[R0 + 4] <- D3\n"
                        +"R0 <- R0 + 8");

        this.codeDB.push("D0 <- D1 + D2\n"
                        +"D2 <- D0 * D1\n"
                        +"D3 <- MEM[R0 + 4]\n"
                        +"D0 <- D0 + D3");

        this.codeDB.push("D0 <- D1 * D2\n"
                        +"D3 <- D0 + D1\n"
                        +"MEM[R0 + 4] <- D3\n"
                        +"MEM[R0 + 12] <- D0");

        this.codeDB.push("D2 <- D0 * D1\n"
                        +"MEM[R0 + 0] <- D2\n"
                        +"D2 <- D0 + D1\n"
                        +"MEM[R0 + 8] <- D2");

        this.bpCodeDB = [];       
/*        this.bpCodeDB.push("R0 <- 0\n"
                          +"R1 <- 0\n"
                          +"R3 <- R0 * 12\n"
                          +"R5 <- R1 * 4\n"
                          +"R3 <- R3 + R5\n"
                          +"R3 <- R3 + R2\n"
                          +"R4 <- MEM[R3+0]\n"
                          +"R4 <- R4 + 1\n"
                          +"MEM[R3+0] <- R4\n"
                          +"R1 <- R1 + 1\n"
                          +"R5 <- R0 + R1\n"
                          +"R5 <- R5 - 3\n"
                          +"JUMP -40 IF R5<0\n"
                          +"R0 <- R0 + 1\n"
                          +"R5 <- R0 - 3\n"
                          +"JUMP -56 IF R5<0");*/
        this.bpCodeDB.push("R0 <- 0\n"
                          +"R1 <- 0\n"
                          +"R3 <- R0 * 128\n"
                          +"R3 <- R3 + R1\n"
                          +"R4 <- MEM[R3+1032]\n"
                          +"R3 <- R1 * 128\n"
                          +"R3 <- R3 + R0\n"
                          +"MEM[R3+4124] <- R4\n"
                          +"R1 <- R1 + 4\n"
                          +"R4 <- R1 - 12\n"
                          +"JUMP -32 IF R4<0\n"
                          +"R0 <- R0 + 4\n"
                          +"R4 <- R0 - 12\n"
                          +"JUMP -48 IF R4<0");

        const Register = chevrotain.createToken({ name: "Register", pattern: /[RUDT]\d+/ });
        const Integer = chevrotain.createToken({ name: "Integer", pattern: /(0x[a-fA-F\d]+)|((-)?(0|[1-9]\d*))/ });
        const Float = chevrotain.createToken({ name: "Float", pattern: /(-)?(0|([1-9]\d*))(\.\d+)?/ });
        const ArithmOp = chevrotain.createToken({ name: "ArithmOp", pattern: /[+-/&|~*]/ });
        const Compare = chevrotain.createToken({ name: "Compare", pattern: /<|>|==|<=|>=/ });
        const Arrow = chevrotain.createToken({ name: "Arrow", pattern: /(<-)|(←)/ });
        const Mem = chevrotain.createToken({ name: "Mem", pattern: /MEM/ });
        const Jump = chevrotain.createToken({ name: "Jump", pattern: /JUMP/ });
        const If = chevrotain.createToken({ name: "If", pattern: /IF/ });
        const BracketLeft = chevrotain.createToken({ name: "BracketLeft", pattern: /\[/ });
        const BracketRight = chevrotain.createToken({ name: "BracketRight", pattern: /\]/ });
        const WhiteSpace = chevrotain.createToken({ name: "WhiteSpace", pattern: /\s+/, group: chevrotain.Lexer.SKIPPED });
        
        // The order of tokens is important
        const allTokens = [ WhiteSpace, Register, Integer, Float, ArithmOp, Arrow, Compare, Mem, Jump, If, BracketLeft, BracketRight ];
        this.lexer = new chevrotain.Lexer(allTokens);        
    }

    parseCode(code) {

        function parseAddress(instr, tokens) {
            if (tokens[0] && tokens[0].tokenType.name === "Integer" && tokens.length === 1) {
                instr.imm = parseInt(tokens[0].image);
                instr.aluOp = "+";
            }
            else if (tokens[0] && tokens[0].tokenType.name === "Register" && tokens.length === 1) {
                instr.imm = 0;
                instr.aluOp = "+";
                instr.regA = tokens[0].image;
            }
            else if (tokens[0] && tokens[0].tokenType.name === "Register"
                    && tokens[1] && tokens[1].tokenType.name === "ArithmOp"
                    && tokens[2] && (tokens[2].tokenType.name === "Register" || tokens[2].tokenType.name === "Integer")
                    && tokens.length === 3) {
                instr.aluOp = tokens[1].image;
                instr.regA = tokens[0].image;
                if (tokens[1].image === "+" || tokens[1].image === "-") {
                    if (tokens[2].tokenType.name === "Register")
                        instr.regB = tokens[2].image;
                    else    
                        instr.imm = parseFloat(tokens[2].image);
                }
                else
                    instr.error = "Only + and - operations are allowed in memory addresses";
            }
            else 
                instr.error = "Invalid arithmetic/logic instruction. First operand must be register, second must be register or immediate constant";
        }

        const instructions = [];
        code.replace(/<-/g, "←").split("\n").forEach((line, ix) => {
            const instr = {line: ix+1, error: "", type: "", subType: "", regA: null, regB: null, aluOp: null, targetReg: null, imm: null, code: line};
            const lexingResult = this.lexer.tokenize(line);            
            instr.error = lexingResult.errors.map(e => e.message).join("; ");
            if (instr.error === "") {
                const tokens = lexingResult.tokens;
                if (tokens[0] && tokens[0].tokenType.name === "Mem" 
                    && tokens[1] && tokens[1].tokenType.name === "BracketLeft") {
                    // store
                    instr.type = "mem";
                    instr.subType = "store";
                    const closingBracket = tokens.findIndex(tok => tok.tokenType.name === "BracketRight");
                    if (closingBracket === -1)
                        instr.error = "Closing bracket not found";
                    else if (tokens[closingBracket+1] && tokens[closingBracket+1].tokenType.name === "Arrow" 
                            && tokens[closingBracket+2] && tokens[closingBracket+2].tokenType.name === "Register" 
                            && tokens.length === closingBracket+3) {
                        instr.regB = tokens[closingBracket+2].image;
                        parseAddress(instr, tokens.slice(2, closingBracket));
                    }
                    else
                        instr.error = "Format of the memory store instruction is not valid (only registers can be stored by the instruction)";
                }
                else if (tokens[0] && tokens[0].tokenType.name === "Register" 
                        && tokens[1] && tokens[1].tokenType.name === "Arrow" 
                        && tokens[2] && tokens[2].tokenType.name === "Mem" 
                        && tokens[3] && tokens[3].tokenType.name === "BracketLeft") {
                    // load
                    instr.type = "mem";
                    instr.subType = "load";
                    const closingBracket = tokens.findIndex(tok => tok.tokenType.name === "BracketRight");
                    if (closingBracket === -1)
                        instr.error = "Closing bracket not found";
                    else if (tokens.length === closingBracket+1) {
                        instr.targetReg = tokens[0].image;
                        parseAddress(instr, tokens.slice(4, closingBracket));
                    }
                    else
                        instr.error = "Invalid tokens after the MEM[] part";
                }
                else if (tokens[0] && tokens[0].tokenType.name === "Register" && tokens[1] && tokens[1].tokenType.name === "Arrow") {
                    // ALU
                    if (tokens[0].image[0] === "R" || tokens[0].image[0] === "U")
                        instr.type = "int";
                    else
                        instr.type = "float";
                    instr.targetReg = tokens[0].image;
                    if (tokens[2] && tokens[2].tokenType.name === "Integer" && tokens.length === 3) {
                        instr.imm = parseInt(tokens[2].image);
                        instr.subType = "+";
                        instr.aluOp = "+";
                    }
                    else if (tokens[2] && tokens[2].tokenType.name === "Register" && tokens.length === 3) {
                        instr.imm = 0;
                        instr.subType = "+";
                        instr.aluOp = "+";
                        instr.regA = tokens[2].image;
                    }
                    else if (tokens[2] && tokens[2].tokenType.name === "Register"
                            && tokens[3] && tokens[3].tokenType.name === "ArithmOp"
                            && tokens[4] && (tokens[4].tokenType.name === "Register" || tokens[4].tokenType.name === "Integer")
                            && tokens.length === 5) {
                        instr.subType = tokens[3].image;
                        instr.aluOp = tokens[3].image;
                        instr.regA = tokens[2].image;
                        if (tokens[4].tokenType.name === "Register")
                            instr.regB = tokens[4].image;
                        else    
                            instr.imm = parseFloat(tokens[4].image);
                    }
                    else 
                        instr.error = "Invalid arithmetic/logic instruction. First operand must be register, second must be register or immediate constant";
                }
                else if (tokens[0] && tokens[0].tokenType.name === "Jump") {                    
                    // Jump
                    if (tokens[1] && tokens[1].tokenType.name === "Integer" && tokens.length === 2) {
                        instr.type = "jump";
                        instr.subType = "direct";
                        instr.imm = parseInt(tokens[1].image);
                    }
                    else if (tokens[1] && tokens[1].tokenType.name === "Register" && tokens.length === 2) {
                        instr.type = "jump";
                        instr.subType = "indirect";
                        instr.regB = tokens[1].image;
                    }
                    else if (tokens[1] && tokens[1].tokenType.name === "Integer" 
                            && tokens[2] && tokens[2].tokenType.name === "If"
                            && tokens[3] && tokens[3].tokenType.name === "Register"
                            && tokens[4] && tokens[4].tokenType.name === "Compare"
                            && tokens[5] && tokens[5].image === "0"
                            && tokens.length === 6) {
                        instr.type = "jump";
                        instr.subType = "conditional/direct";
                        instr.regA = tokens[3].image;
                        instr.imm = parseInt(tokens[1].image);
                        instr.aluOp = tokens[4].image;
                    }
                    else if (tokens[1] && tokens[1].tokenType.name === "Register" 
                            && tokens[2] && tokens[2].tokenType.name === "If"
                            && tokens[3] && tokens[3].tokenType.name === "Register"
                            && tokens[4] && tokens[4].tokenType.name === "Compare"
                            && tokens[5] && tokens[5].image === "0"
                            && tokens.length === 6) {
                        instr.type = "jump";
                        instr.subType = "conditional/direct";
                        instr.regA = tokens[3].image;
                        instr.regB = tokens[1].image;                        
                        instr.aluOp = tokens[4].image;
                    }
                    else 
                        instr.error = "Invalid jump instruction. Conditions (if any) must compare a register to 0."
                }
                else {
                    instr.error  = "Unknown/unsupported instruction";
                }
            }
            instructions.push(instr);
        });
        return instructions;
    }

    getPathForInstruction(instr, pipelineModel) {
        if (instr.type + "." + instr.subType in pipelineModel.paths)
            return pipelineModel.paths[instr.type + "." + instr.subType];
        else if (instr.type + "*" in pipelineModel.paths)
            return pipelineModel.paths[instr.type + "*"];
        else if ("*" in pipelineModel.paths)
            return pipelineModel.paths["*"];
        else return null;
    }

    fitsPipeline(instrList, pipelineModel) {
        return instrList.every(instr => this.getPathForInstruction(instr, pipelineModel));
    }

    getRandomCode(pipelineModel) {
        let choices = this.codeDB;
        if (pipelineModel)
            choices = this.codeDB.filter(code => this.fitsPipeline(this.parseCode(code), pipelineModel));
        return this.perturbeCode(_.sample(choices));
    }

    getRandomCodeForBranchPrediction() {
        const code = _.sample(this.bpCodeDB);
        const instrList = this.parseCode(code);
        this.permuteRegisters(instrList);
        return this.buildCode(instrList);
    }

    permuteRegisters(instrList) {

        function replaceReg(reg, intRegs, floatRegs) {
            if (!reg || reg === "PC")
                return reg;
            const regIx = parseInt(reg.substr(1));
            if (reg[0] === "D")
                return floatRegs[regIx];
            else
                return intRegs[regIx];
        }
        // collect all registers
        //const regs = _.uniq([].concat(...instrList.map(instr => [instr.targetReg, instr.regA, instr.regB]))).filter(x => x && x !== "PC");
        const newIntRegs = _.shuffle(_.range(8).map((v,ix)=> "R"+ix));
        const newFloatRegs = _.shuffle(_.range(4).map((v,ix)=> "D"+ix));
        instrList.forEach(instr => {
            instr.targetReg = replaceReg(instr.targetReg, newIntRegs, newFloatRegs);
            instr.regA = replaceReg(instr.regA, newIntRegs, newFloatRegs);
            instr.regB = replaceReg(instr.regB, newIntRegs, newFloatRegs);
        });
    }

    modifyOperations(instrList) {
        instrList.forEach(instr => {
            if ((instr.type === "int" || instr.type === "float") && (instr.subType === "+" || instr.subType === "-")) {
                if (Math.random() < 0.5) {
                    instr.subType = "+";
                    instr.aluOp = "+";
                }
                else {
                    instr.subType = "-";
                    instr.aluOp = "-";
                }                
            }
            else if (instr.type === "mem" && instr.imm !== 0) {
                if (Math.random() < 0.5)
                    instr.aluOp = "+";
                else
                    instr.aluOp = "-";
            }
        });
    }

    modifyConstants(instrList) {
        const addressMod = Math.round(Math.random()*6)*4;
        instrList.forEach(instr => {
            if ((instr.type === "int" || instr.type === "float") && instr.imm)
                instr.imm = Math.round(Math.random()*64);
            else if (instr.type === "mem" && instr.imm)
                instr.imm += addressMod;
        });
    }

    buildCode(instrList) {
        return instrList.map(instr => {
            if (instr.type === "int" || instr.type === "float") {
                if (!instr.regA && !instr.regB)
                    return `${instr.targetReg} <- ${instr.imm}`;
                else if (!instr.regB)
                    return `${instr.targetReg} <- ${instr.regA} ${instr.aluOp} ${instr.imm}`;
                else
                    return `${instr.targetReg} <- ${instr.regA} ${instr.aluOp} ${instr.regB}`;
            }
            else if (instr.type === "mem" && instr.subType === "store") {
                if (!instr.regA)
                    return `MEM[${instr.imm}] <- ${instr.regB}`;
                else
                   return `MEM[${instr.regA} ${instr.aluOp} ${instr.imm}] <- ${instr.regB}`;
            }
            else if (instr.type === "mem" && instr.subType === "load") {
                if (!instr.regA)
                    return `${instr.targetReg} <- MEM[${instr.imm}]`;
                else
                   return `${instr.targetReg} <- MEM[${instr.regA} ${instr.aluOp} ${instr.imm}]`;
            }
            else if (instr.type === "jump" && instr.subType === "direct")
                return `JUMP ${instr.imm}`;
            else if (instr.type === "jump" && instr.subType === "indirect")
                return `JUMP ${instr.regB}`;
            else if (instr.type === "jump" && instr.subType === "conditional/direct")
                return `JUMP ${instr.imm} IF ${instr.regA} ${instr.aluOp} 0`;
            else if (instr.type === "jump" && instr.subType === "conditional/indirect")
                return `JUMP ${instr.regB} IF ${instr.regA} ${instr.aluOp} 0`;
            return "Unexpected instruction " + instr.type;
        }).join("\n");
    }

    perturbeCode(code) {
        const instrList = this.parseCode(code);
        this.permuteRegisters(instrList);
        this.modifyOperations(instrList);
        this.modifyConstants(instrList);
        return this.buildCode(instrList);
    }
}

const codeManager = new CodeManager();
export default codeManager;
